module.exports = __webpack_public_path__ + "static/media/indexBG.9311188b.png";